import type { FaireProductEntity } from "../../entity_types/product";

export const p_h8eyp679en: FaireProductEntity = {
  token: "p_h8eyp679en",
  type: "product",
  name: "Prism Lotus Blooms – Glass Crystal Lotus Figurines",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/e8d2bb1d0acb833431da785451adb8204f21117943683ae79e6aeae7c0a48bf5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96dce7fd01fcefecaa452cf75e392eaf6a5e706e3e6651157b402e3753d80bd0.jpeg",
    "https://cdn.faire.com/fastly/d20b3fd79ab0784828e3a2bbe5cb6745520fed4ee237bf8a4cc96b70c23207fb.jpeg",
    "https://cdn.faire.com/fastly/16a250ed87844b9df537e439347d17f5cb70d17cd7414120a0dc27b89dda393e.jpeg",
    "https://cdn.faire.com/fastly/ce0e8978577be26fb3a771ce6f2cbd557db2a8e712453fa2a502e574cea57765.jpeg",
    "https://cdn.faire.com/fastly/5139a573b9b1517e28b0b1414c26671a77bf754aa0a725e985945b68eecb85c2.jpeg",
    "https://cdn.faire.com/fastly/3c56c6f29becf562ba6dad4bcdd1cba23aaa7f604b6a2fb6731ec63dd20ea541.jpeg",
    "https://cdn.faire.com/fastly/b1eefba2bf9981300441ca442fbe4dd94504ff5ba79645cf606d07664877db67.jpeg",
    "https://cdn.faire.com/fastly/58f424211dedd25a56e06232706935302cca78b99bcfb70d4c1131767de2cd79.jpeg",
    "https://cdn.faire.com/fastly/82c6ff0bb34754cb200b103a67738b4a3bbf90901585cebbde0860d72d9eeecc.jpeg",
    "https://cdn.faire.com/fastly/a9d3be08b35e9b0726dc31f7df2fc186945e1f7691374b385c08fdfe2a48373e.jpeg",
    "https://cdn.faire.com/fastly/d49c3ce327fc7ec7bed8774fb1ce5e0efff3ec03b55c0612d41bb351c5d627fd.jpeg",
    "https://cdn.faire.com/fastly/0c3142f4ff35fff7549d99d2071b738bc679afa78251ff6eba260defb9b4c756.jpeg",
    "https://cdn.faire.com/fastly/f47d8bdf51e2932a62ded7ff58e68fc819298685ae07fbe62b36db3f66bedc27.jpeg",
  ],
  priceDollars: 9.69,
  description:
    "Add instant sparkle to any shelf, gift table, or meditation corner with our Prism Lotus Blooms. These stunning lotus figurines are crafted from high-clarity glass and cut to a crystal-like shape, creating beautiful light-catching reflections from every angle. The lotus symbolizes peace, renewal, and inner strength—making these an easy “yes” for customers shopping for meaningful décor and gifts.\n\nWhat’s Included:\n6-color assorted set (colors may include red, pink, blue, green, purple, yellow)\nEach piece features multi-faceted “crystal” petals for maximum shine\n\nWhy Retailers Love Them\nEye-catching sparkle that sells itself in-store\nPerfect for gift shops, boutiques, yoga/wellness spaces, and home décor stores\nGreat for shelves, desks, nightstands, altars, and meditation areas\nStrong gift appeal for birthdays, housewarmings, and self-care moments\n\nProduct Details\nMaterial: faceted glass (crystal-look finish)\nAssortment: 6 colors\nBoxing: It comes in a kraft box",
  tags: [],
  msrpDollars: 20.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:21.376Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
